module.exports = __webpack_public_path__ + "img/gpy9.ffdb36bb.png";